export const ProductType = {
  LifeProtection: 'Life Protection',
  ChildrensCriticalIllnessProtection: 'Childrens Critical Illness Protection',
  CriticalIllnessProtection: 'Critical Illness Protection',
  CriticalIllnessEssentials: 'Critical Illness Essentials',
  LifeEssentials: 'Life Essentials',
  CombinedLifeAndCriticalIllnessEssentials:
    'Combined Life and Critical Illness Essentials',
  IncomeProtection: 'Income Protection',
  CombinedLifeAndCriticalIllnessProtection:
    'Combined Life and Critical Illness Protection',
  FracturePlusProtection: 'Fracture Plus Protection',
};

export const ProductCoverType = {
  Level: 'level',
  Increasing: 'increasing',
  Decreasing: 'decreasing',
  Family: 'family',
};

export const ProductPaymentPeriod = {
  FullTerm: 'Full term',
};

export const DecisionType = {
  STANDARD: 'STANDARD',
  NON_STANDARD: 'NON_STANDARD',
  REFER: 'REFER',
  EVIDENCE_REQUIRED: 'EVIDENCE_REQUIRED',
  POSTPONE: 'POSTPONE',
  DECLINE: 'DECLINE',
  IN_FORCE: 'IN_FORCE',
};

export const decisionTypeColor = {
  STANDARD: 'green',
  NON_STANDARD: 'green',
  REFER: 'orange',
  EVIDENCE_REQUIRED: 'orange',
  POSTPONE: 'red',
  DECLINE: 'red',
};
